/**
 * xelara-footer.js — BUILD-ORDER D11.12
 * Turns Dawn's footer link columns into accordions on phones (≤767px).
 * The toggle button is in the markup but `hidden`; it is revealed here so
 * the columns stay plain lists without JS. Vanilla, no deps.
 */
const mq = matchMedia('(max-width: 767px)');

function bind(block, btn) {
  const content = block.querySelector('.footer-block__details-content');
  if (!content) return;
  content.id = btn.getAttribute('aria-controls');
  btn.hidden = false;
  btn.addEventListener('click', () => {
    const open = block.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
  });
}

export function init(scope = document) {
  scope.querySelectorAll('.xel-footer--accordion .footer-block').forEach((block) => {
    const btn = block.querySelector('.xel-footer__toggle');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    bind(block, btn);
  });
  // Wider than a phone, everything is open regardless of state.
  const sync = () => {
    scope.querySelectorAll('.xel-footer--accordion .footer-block').forEach((block) => {
      const btn = block.querySelector('.xel-footer__toggle');
      if (!btn) return;
      if (!mq.matches) {
        block.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  };
  mq.addEventListener('change', sync);
  sync();
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
}
